/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLocalBugDb = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2v6h2V4h4V2zm14 2h4v4h2V2h-6zM6 6v12h12V6zm2 10V8h8v8zm-4 0v4h4v2H2v-6zm12 6v-2h4v-4h2v6zm-4-12v2h2v2h-4v-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLocalBugDb as LocalBugDb };
